import { Component, OnInit, OnDestroy, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CameraComponent } from '../camera/camera.component';
import { DeviceSelectComponent } from '../device-select/device-select.component';
import { debounceTime } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { DeviceService } from 'src/app/services/device.service';

@Component({
  selector: 'app-twilio-settings',
  templateUrl: './twilio-settings.component.html',
  styleUrls: ['./twilio-settings.component.scss'],
})
export class TwilioSettingsComponent implements OnInit, OnDestroy {
  public devices: MediaDeviceInfo[] = [];
  private subscription: Subscription;
  private videoDeviceId: string;
  isDeviceEmptyArray: boolean = false;

  get hasAudioInputOptions(): boolean {
      return this.devices && this.devices.filter(d => d.kind === 'audioinput').length > 0;
  }
  get hasAudioOutputOptions(): boolean {
      return this.devices && this.devices.filter(d => d.kind === 'audiooutput').length > 0;
  }
  get hasVideoInputOptions(): boolean {
      return this.devices && this.devices.filter(d => d.kind === 'videoinput').length > 0;
  }

  @ViewChild('camera') camera: CameraComponent;
  @ViewChild('videoSelect') video: DeviceSelectComponent;

  @Input('isPreviewing') isPreviewing: boolean;
  @Output() settingsChanged = new EventEmitter<MediaDeviceInfo>();

  constructor(
      private readonly deviceService: DeviceService) { }

  ngOnInit() {
      this.subscription =
          this.deviceService
              .$devicesUpdated
              .pipe(debounceTime(350))
              .subscribe(async deviceListPromise => {
                  this.devices = await deviceListPromise;
                  this.handleDeviceAvailabilityChanges();
                  if(this.isDeviceEmptyArray){
                    this.showPreviewCamera();
                  }
              });
  }

  ngOnDestroy() {
      if (this.subscription) {
          this.subscription.unsubscribe();
      }
  }

  async onSettingsChanged(deviceInfo: MediaDeviceInfo) {
      if (this.isPreviewing) {
          await this.showPreviewCamera();
      } else {
          this.settingsChanged.emit(deviceInfo);
      }
  }

  async showPreviewCamera() {
      this.isPreviewing = true;
      if(this.devices.length == 0){
          this.isDeviceEmptyArray = true;
      } else {
        this.isDeviceEmptyArray = false;
        const videoDevice = this.devices[0];
        await this.camera.initializePreview(videoDevice);
      }
     
    //   if (this.videoDeviceId !== this.video.selectedId) {
    //       this.videoDeviceId = this.video.selectedId;
    //       const videoDevice = this.devices.find(d => d.deviceId === this.video.selectedId);
    //       await this.camera.initializePreview(videoDevice);
    //   }else if (this.videoDeviceId == this.video.selectedId){
    //       const videoDevice = this.devices.find(d => d.deviceId === this.video.selectedId);
    //       await this.camera.initializePreview(videoDevice);
    //   }
      
      return this.camera.tracks;
  }

  async hidePreviewCamera() {
      this.isPreviewing = false;
      await this.camera.finalizePreview();
      return true;
  }

  private handleDeviceAvailabilityChanges() {
      if (this.devices && this.devices.length && this.video && this.video.selectedId) {
          let videoDevice = this.devices.find(d => d.deviceId === this.video.selectedId);
          if (!videoDevice) {
              videoDevice = this.devices.find(d => d.kind === 'videoinput');
              if (videoDevice) {
                  this.video.selectedId = videoDevice.deviceId;
                  this.onSettingsChanged(videoDevice);
              }
          }
      }
  }

  toggleVideo(flag) {
      if(flag) {
        this.showPreviewCamera();
      } else {
        this.camera.stopCamera();
      }
  }

}
